import React, { useEffect, useState } from "react";
import { useCookies } from "react-cookie";
import { QRCodeCanvas } from "qrcode.react"; // ✅ 최신 문법
import { FiCopy } from "react-icons/fi";

const styles = {
  page: {
    minHeight: "100vh",
    background: "linear-gradient(135deg, #0b0f14, #0a0a0c)",
    color: "#e7e7e9",
    padding: "48px 16px 72px",
    fontFamily: "'Pretendard', 'Noto Sans KR', system-ui, -apple-system, sans-serif",
    boxSizing: "border-box",
  },
  container: {
    maxWidth: "1080px",
    margin: "0 auto",
    display: "flex",
    flexDirection: "column",
    gap: "20px",
  },
  card: {
    background: "rgba(255,255,255,0.04)",
    border: "1px solid rgba(255,255,255,0.07)",
    boxShadow: "0 20px 40px rgba(0,0,0,0.32)",
    borderRadius: "18px",
    padding: "22px 20px",
  },
  title: {
    margin: 0,
    fontSize: "28px",
    fontWeight: 800,
    color: "#fff",
    letterSpacing: "-0.02em",
  },
  helper: {
    color: "#cbd5e1",
    fontSize: "13px",
    lineHeight: 1.6,
    margin: "4px 0 10px",
  },
  infoRow: {
    display: "flex",
    gap: "8px",
    flexWrap: "wrap",
    marginBottom: "8px",
  },
  tag: {
    background: "rgba(255,255,255,0.06)",
    border: "1px solid rgba(255,255,255,0.12)",
    borderRadius: "10px",
    padding: "8px 10px",
    fontWeight: 700,
    color: "#f8fafc",
    fontSize: "13px",
  },
  plansGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
    gap: "14px",
  },
  planCard: {
    background: "rgba(255,255,255,0.04)",
    border: "1px solid rgba(255,255,255,0.08)",
    borderRadius: "14px",
    padding: "16px",
    boxShadow: "0 14px 26px rgba(0,0,0,0.26)",
  },
  planHeader: {
    margin: "0 0 10px",
    color: "#f8fafc",
    fontWeight: 800,
    fontSize: "17px",
  },
  planItems: {
    display: "grid",
    gap: "10px",
  },
  planItem: {
    background: "rgba(255,255,255,0.03)",
    border: "1px solid rgba(255,255,255,0.08)",
    borderRadius: "12px",
    padding: "12px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  planName: {
    color: "#f8fafc",
    fontWeight: 700,
  },
  planDesc: {
    color: "#cbd5e1",
    fontSize: "13px",
    marginTop: "4px",
  },
  primaryBtn: {
    padding: "10px 12px",
    borderRadius: "10px",
    border: "1px solid rgba(255,255,255,0.12)",
    background: "linear-gradient(120deg, #fb923c, #f97316)",
    color: "#130903",
    fontWeight: 800,
    cursor: "pointer",
    boxShadow: "0 10px 22px rgba(249,115,22,0.24)",
    minWidth: "96px",
  },
  ghostBtn: {
    padding: "10px 12px",
    borderRadius: "10px",
    border: "1px solid rgba(255,255,255,0.12)",
    background: "rgba(255,255,255,0.05)",
    color: "#f8fafc",
    fontWeight: 700,
    cursor: "pointer",
  },
  modalOverlay: {
    position: "fixed",
    inset: 0,
    background: "rgba(0,0,0,0.65)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 2000,
    padding: "16px",
  },
  modal: {
    background: "rgba(15,15,20,0.95)",
    border: "1px solid rgba(255,255,255,0.12)",
    borderRadius: "16px",
    padding: "20px 18px",
    width: "100%",
    maxWidth: "560px",
    maxHeight: "85vh",
    overflowY: "auto",
    boxShadow: "0 20px 48px rgba(0,0,0,0.45)",
  },
  modalTitle: {
    margin: "0 0 6px",
    color: "#fff",
    fontSize: "20px",
    fontWeight: 800,
  },
  warning: {
    color: "#fca5a5",
    fontSize: "13px",
    marginBottom: "14px",
    textAlign: "left",
    lineHeight: 1.5,
  },
  depositBox: {
    background: "rgba(255,255,255,0.03)",
    border: "1px solid rgba(255,255,255,0.08)",
    borderRadius: "12px",
    padding: "12px",
    marginBottom: "12px",
  },
  addrRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "8px",
    wordBreak: "break-all",
  },
  copyBtn: {
    padding: "6px 8px",
    borderRadius: "8px",
    border: "1px solid rgba(255,255,255,0.12)",
    background: "rgba(255,255,255,0.05)",
    color: "#f8fafc",
    cursor: "pointer",
  },
  depositBtn: {
    width: "100%",
    marginTop: "10px",
    padding: "10px 12px",
    borderRadius: "10px",
    border: "1px solid rgba(255,255,255,0.12)",
    background: "linear-gradient(120deg, #fb923c, #f97316)",
    color: "#130903",
    fontWeight: 800,
    cursor: "pointer",
    boxShadow: "0 10px 22px rgba(249,115,22,0.24)",
  },
  modalActions: {
    display: "flex",
    justifyContent: "flex-end",
    gap: "10px",
    marginTop: "10px",
  },
  footerActions: {
    display: "flex",
    justifyContent: "center",
    marginTop: "24px",
    gap: "10px",
  },
};

export default function PaymentPage() {
  const fixedAddr1 = "0xc817b323df6612c53ba43d748fa070eb0a074e11"; 
  const fixedAddr2 = "0x070740809981b896f2429137345fe52025cdebfa";
  const [cookies] = useCookies(["uuid"]);
  const [uid, setUid] = useState("");
  const [nickname, setNickname] = useState("");
  const [email, setEmail] = useState("");
  const [grade, setGrade] = useState("");
  const [exPeriod, setExPeriod] = useState("");

  const planGroups = [
    { 
      groupName: "실버 (SET 10000 제한)", 
      plans: [
        { name: "기본", days: "", extra: "30 일", amount1: 30, amount2: 70 },
      ]
    },
    { 
      groupName: "골드 (무제한)", 
      plans: [
        { name: "기본", days: "", extra: "30 일", amount1: 60, amount2: 140 },
      ]
    },
  ];

  const [showPopup, setShowPopup] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState(null);

  const handlePurchaseClick = (plan) => {
    setSelectedPlan(plan);
    setShowPopup(true);
  };

  const handleCopy = (text) => {
    navigator.clipboard.writeText(text);
    alert("주소가 복사되었습니다");
  };

  const handleDepositGuide = () => {
    // XT 사이트로 이동 (주소 및 금액은 사용자가 입력)
    window.open("https://www.xt.com/en/accounts/assets/wallet/withdraw", "_blank");
  };

  useEffect(() => {
    const uuid = cookies.uuid;
    if (!uuid) return;
    fetch(`/SetPage/user?uuid=${uuid}`)
      .then((res) => res.json())
      .then((data) => {
        const user = data?.[0];
        if (user) {
          setUid(user.uid != null ? String(user.uid) : "");
          setNickname(String(user.nickname ?? ""));
          setEmail(String(user.email ?? ""));
          setGrade(user.grade || "");
          setExPeriod(user.ex_period || "");
        }
      })
      .catch((err) => console.error("결제페이지 사용자 정보 조회 오류:", err));
  }, [cookies.uuid]);

  const renderDepositBox = (label, amount, address) => (
    <div style={styles.depositBox}>
      <p>
        입금USDT : <span style={{ fontSize: "1.2em", fontWeight: "bold" }}>{amount}</span> USDT
      </p>
      <p style={styles.addrRow}>
        <span>{label} : {address}</span>
        <button
          style={styles.copyBtn}
          onClick={() => handleCopy(address)}
        >
          <FiCopy size={16} />
        </button>
      </p>
      <div style={{ display: "flex", justifyContent: "center", marginTop: "10px" }}>
        <QRCodeCanvas value={address} size={128} />
      </div>
      <button style={styles.depositBtn} onClick={handleDepositGuide}>입금하기</button>
    </div>
  );

  return (
    <div style={styles.page}>
      <div style={styles.container}>
        <div style={styles.card}>
          <h1 style={styles.title}>결제 페이지</h1>
          <div style={styles.infoRow}>
            <span style={styles.tag}>UID: {uid || "-"}</span>
            <span style={styles.tag}>{nickname ? `${nickname}님` : "닉네임: -"}</span>
            <span style={styles.tag}>{email || "-"}</span>
            <span style={styles.tag}>등급: {grade || "-"}</span>
            <span style={styles.tag}>사용기한: {exPeriod || "-"}</span>
          </div>
          <p style={styles.helper}>
            원하는 플랜을 선택해 주세요. 각 플랜은 두 주소에 분할 입금이 필요하며, BEP20 네트워크로 전송해야 합니다.
          </p>
          <div style={styles.plansGrid}>
            {planGroups.map((group) => (
              <div style={styles.planCard} key={group.groupName}>
                <h2 style={styles.planHeader}>{group.groupName}</h2>
                <div style={styles.planItems}>
                  {group.plans.map((p) => (
                    <div key={p.name} style={styles.planItem}>
                      <div>
                        <div style={styles.planName}>{p.name}</div>
                        <div style={styles.planDesc}>{p.extra}</div>
                      </div>
                      <button
                        style={styles.primaryBtn}
                        onClick={() => handlePurchaseClick(p)}
                      >
                        구매하기
                      </button>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* ✅ 모달 팝업 */}
        {showPopup && selectedPlan && (
          <div style={styles.modalOverlay}>
            <div style={styles.modal}>
              <h3 style={styles.modalTitle}>{selectedPlan.name} 결제</h3>
              <p style={styles.helper}>{selectedPlan.days} {selectedPlan.extra}</p>

              <p style={styles.warning}>
                ⚠ 두 주소에 각각 금액을 입금해야 합니다.<br />
                ⚠ 주소(USDT)와 네트워크(BEP20), 금액을 반드시 확인하세요.<br />
                ⚠ 잘못된 입금은 복구 불가합니다.<br />
                <span style={{ color: "#f87171", fontWeight: 700 }}>
                ⚠ 다른 등급으로 입금 시 입금일 기준 사용기한이 적용됩니다.<br />
                * 낮은 등급에서 높은 등급, 높은 등급에서 낮은 등급으로 입금 시에도 동일하게 적용 *<br />
                </span>
                ⚠ 같은 등급으로 입금 시 남은 기한에서 연장 적용됩니다.
              </p>

              {renderDepositBox("입금주소 1", selectedPlan.amount1, fixedAddr1)}
              {renderDepositBox("입금주소 2", selectedPlan.amount2, fixedAddr2)}

              <div style={styles.modalActions}>
                <button style={styles.ghostBtn} onClick={() => setShowPopup(false)}>닫기</button>
              </div>
            </div>
          </div>
        )}

        <div style={styles.footerActions}>
          <button style={styles.ghostBtn} onClick={() => window.location.href = "/SelectPage"}>취소</button>
        </div>
      </div>
    </div>
  );
}
